import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index'
import store from '@/store/index'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueAxios from 'vue-axios'
import VueMask from 'v-mask'
import axios from '@/utils/init-axios'
import { States } from '@/plugins/states'
/* vue-fontawesome icons */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
/* components */
import infoComponents from '@/plugins/infoComponents'
/* styles */
/* validation */
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import VueCurrencyInput from 'vue-currency-input'
import VueTelInput from 'vue-tel-input'
import Vuelidate from 'vuelidate'

import 'vue-search-select/dist/VueSearchSelect.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/scss/main.scss'

import Toasted from 'vue-toasted'

/* add vue-fa icons to library */
library.add(faTimesCircle)

Vue.use(BootstrapVue)

const currencyOptions = {
  globalOptions: { currency: 'USD' }
}
Vue.use(VueCurrencyInput, currencyOptions)

Vue.use(IconsPlugin)
Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VueAxios, axios)
Vue.use(Toasted)
Vue.use(States)
Vue.use(VueTelInput) 

/* global component initialization  */
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('LabeledInfo', infoComponents.LabeledInfo)

/* vee-validate component initialization */
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

/* Set the access for quickest possible auth access */
const accessToken = localStorage.getItem('blytzpay_access_token')
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`

new Vue({
  router,
  store,
  beforeCreate() {
    /* Also refresh the access token on initial load */
    const refreshToken = localStorage.getItem('blytzpay_refresh_token')
    if (refreshToken) {
      this.$store
        .dispatch('refreshAccess')
        .then(res => {
          this.$store.commit('setLastActivity')
          this.axios.defaults.headers.common[
            'Authorization'
          ] = `Bearer ${res.data.access}`
          this.$store.dispatch('getProfile')
          this.$store.dispatch('getMerchant', {
            merchantID: this.$route.params?.merchantID
          })
          this.$store.dispatch('getMerchantCount')
        })
        .catch(err => {
          console.log('failed to refresh Access', err)
        })
    }
  },
  render: h => h(App)
}).$mount('#app')
